// ============================================================================
// aniversariosHoje — regra única de "faz aniversário hoje" (16/10/2026)
// ============================================================================
// Usada pela página /gestao/aniversarios e pela bolinha vermelha do menu
// (useAvisoAniversario). O push do servidor usa a MESMA regra em
// api/_lib/aniversarios.js (a API não importa de src/; um teste confere as
// duas, dia a dia, em 2027 e 2028).
//   - birthday 'YYYY-MM-DD' (ou ISO); ano 2000 = cadastro sem ano (sem idade);
//   - 29/02 em ano não bissexto comemora em 28/02;
//   - ativo = p.active !== false && !p.deletedAt;
//   - "hoje" é sempre o dia de São Paulo (hojeSP, src/utils/dataSP.js), que
//     quem chama passa como 'YYYY-MM-DD'.
// Sem React, sem rede, sem armazenamento.
// ============================================================================

export const ANO_SEM_ANO = 2000;

export function ehBissexto(ano) {
  return (ano % 4 === 0 && ano % 100 !== 0) || ano % 400 === 0;
}

// 'YYYY-MM-DD…' → { ano, mes, dia } | null
export function partesAniversario(birthday) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(birthday || ''));
  if (!m) return null;
  const ano = Number(m[1]), mes = Number(m[2]), dia = Number(m[3]);
  if (mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
  return { ano, mes, dia };
}

// Dia do ano `ano` em que se comemora (29/02 em ano não bissexto → 28/02).
export function diaDaComemoracao(mes, dia, ano) {
  if (mes === 2 && dia === 29 && !ehBissexto(ano)) return { mes: 2, dia: 28 };
  return { mes, dia };
}

export function fazAniversarioEm(birthday, hojeISO) {
  const b = partesAniversario(birthday);
  const h = partesAniversario(hojeISO);
  if (!b || !h) return false;
  const c = diaDaComemoracao(b.mes, b.dia, h.ano);
  return c.mes === h.mes && c.dia === h.dia;
}

// Dias até a próxima comemoração (0 = hoje). null se a data não serve.
export function diasAteAniversario(birthday, hojeISO) {
  const b = partesAniversario(birthday);
  const h = partesAniversario(hojeISO);
  if (!b || !h) return null;
  const hojeMs = Date.UTC(h.ano, h.mes - 1, h.dia);
  for (const ano of [h.ano, h.ano + 1]) {
    const c = diaDaComemoracao(b.mes, b.dia, ano);
    const ms = Date.UTC(ano, c.mes - 1, c.dia);
    // dia que não existe no mês (ex.: 31/04) não vira o dia seguinte
    if (new Date(ms).getUTCDate() !== c.dia) return null;
    if (ms >= hojeMs) return Math.round((ms - hojeMs) / 86400000);
  }
  return null;
}

// Idade que a pessoa faz no ano de hoje (null sem ano ou ano 2000).
export function idadeEm(birthday, hojeISO) {
  const b = partesAniversario(birthday);
  const h = partesAniversario(hojeISO);
  if (!b || !h || b.ano === ANO_SEM_ANO || b.ano > h.ano) return null;
  return h.ano - b.ano;
}

export const ehAtivo = (p) => !!p && p.active !== false && !p.deletedAt;

// Os aniversariantes de hoje (rede inteira; os mesmos que a página mostra em "Hoje").
export function aniversariantesHoje(profs, hojeISO) {
  return (profs || []).filter(p => ehAtivo(p) && fazAniversarioEm(p?.birthday, hojeISO));
}

// A bolinha aparece quando há aniversariante hoje e a pessoa ainda não abriu a
// página hoje (vistoEm = o dia SP em que abriu pela última vez).
export function deveMostrarSelo({ n, vistoEm, hoje } = {}) {
  return Number(n) > 0 && !!hoje && vistoEm !== hoje;
}
